import { useState } from 'react';

import { EuiGlobalToastList, type EuiGlobalToastListToast } from '@elastic/eui';

import { setToastHandler, TOAST_LIFETIME_MS } from './index';

type CustomToast = Omit<EuiGlobalToastListToast, 'id'>;

let nextToastId = 0;

export const Toasts = () => {
  const [toasts, setToasts] = useState<EuiGlobalToastListToast[]>([]);

  const removeToast = (toast: EuiGlobalToastListToast) => {
    setToasts((prevState) => prevState.filter(({ id }) => id !== toast.id));
  };

  const addToastHandler = (toast: CustomToast) => {
    setToasts((prevState) => [
      ...prevState,
      { id: `${nextToastId++}`, ...toast },
    ]);
  };

  // Register the toast handler
  setToastHandler(addToastHandler);

  return (
    <EuiGlobalToastList
      toasts={toasts}
      dismissToast={removeToast}
      toastLifeTimeMs={TOAST_LIFETIME_MS}
      showClearAllButtonAt={0}
    />
  );
};
